import { FelaCSS, FelaCSSWithCustomSelectors } from '../../../../components/fela/flowtypes';
import { alpha } from '../../../../fela-utils/color-mixer';
import { colors } from '../../../../themes/variables';
import InputStyles from '../input/input.style';

interface IStyleProps {
  disabled?: boolean;
  icon?: boolean;
  iconWidth?: number;
}

interface StyleTypes {
  wrapper: FelaCSS;
  inputWrapper: FelaCSS;
  iconWrap: FelaCSS;
  autosuggestWrap: FelaCSSWithCustomSelectors;
}

const styles = ({ disabled, icon, iconWidth }: IStyleProps): StyleTypes => {
  const SharedStyle = InputStyles({
    disabled,
    icon,
    iconWidth,
  });
  const shadowColor = alpha(colors.indigoCrush80, 20);

  return {
    wrapper: {
      display: 'inline-flex',
      flexShrink: 0,
      zIndex: 100,
      position: 'relative',
      width: '100%',
    },

    inputWrapper: {
      ...SharedStyle.inputWrapper,
    },

    iconWrap: {
      ...SharedStyle.iconWrap,
    },

    autosuggestWrap: {
      '> .react-autosuggest__container.react-autosuggest__container--open': {
        '> input': {
          borderBottomLeftRadius: '0',
          borderBottomRightRadius: '0',
          borderColor: colors.indigoCrush80,
        },

        '> .react-autosuggest__suggestions-container': {
          position: 'absolute',
          left: '0',
          top: '44px',
          zIndex: 1,
          padding: '0',
          margin: '0',
          width: '100%',
          boxSizing: 'border-box',
          listStyle: 'none',
          backgroundColor: colors.white,
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: colors.indigoCrush80,
          borderTop: 'none',
          borderBottomLeftRadius: '4px',
          borderBottomRightRadius: '4px',
          boxShadow: `2px 2px 4px 0 ${shadowColor}`,
          overflow: 'hidden',

          '> .react-autosuggest__suggestions-list': {
            marginTop: '0',
            marginBottom: '0',
            paddingLeft: '0',
            listStyle: 'none',
          },
        },
      },

      '> .react-autosuggest__container': {
        position: 'relative',
        display: 'flex',

        '> input': {
          ...SharedStyle.input,
          backgroundColor: colors.white,
          width: '100%',
        },
      },
    },
  };
};

export default styles;
